







































import {
  IVacationCarryOverRequestData,
  VacationCarryOverRequestStateEnum
} from '@/models';

import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    request: {
      type: Object as PropType<IVacationCarryOverRequestData>
    },

    canRejectOrApproveState: Boolean,
    canCancel: Boolean
  },

  data() {
    return {
      VacationCarryOverRequestStateEnum
    };
  },

  computed: {
    buttonPositionStyle(): string {
      return this.canRejectOrApproveState && this.canCancel
        ? 'justify-space-between'
        : 'justify-end';
    },

    cancelButtonStyle() {
      return this.canRejectOrApproveState ? 'cancel-request' : 'white--text';
    },

    cancelText(): string {
      return this.request.state == VacationCarryOverRequestStateEnum.Approved
        ? 'Cancel Approved Request'
        : 'Cancel';
    }
  },

  methods: {
    openCommentDialog(state: VacationCarryOverRequestStateEnum) {
      this.$emit('openCommentDialog', state);
    }
  }
});
